import React from "react"
import { injectIntl } from "gatsby-plugin-intl"

const AboutWhatWeDo = ( { intl } ) => {
  return (
    <div className="block text what-we-do">
      <label className="label hidden">{ intl.formatMessage( { id: "about.what-we-do.label" } ) }</label>
      <div className="content text">
        <h2 className="title hidden">{ intl.formatMessage( { id: "about.what-we-do.title1" } ) }</h2>
        <p className="text hidden">{ intl.formatMessage( { id: "about.what-we-do.text1" } ) }</p>
        <h2 className="title hidden">{ intl.formatMessage( { id: "about.what-we-do.title2" } ) }</h2>
        <p className="text hidden">{ intl.formatMessage( { id: "about.what-we-do.text2" } ) }</p>
        <h2 className="title hidden">{ intl.formatMessage( { id: "about.what-we-do.title3" } ) }</h2>
        <p className="text hidden">{ intl.formatMessage( { id: "about.what-we-do.text3" } ) }</p>
      </div>
    </div>
  )
}

const inject = injectIntl( AboutWhatWeDo )

export { inject as AboutWhatWeDo }
